var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPassages(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "pasajes",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_202",
    "data-name": "Rectangle 202",
    width: 60,
    height: 45,
    transform: "translate(622 625)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    width: 57.638,
    height: 34.173,
    transform: "translate(9)",
    fill: "#85af26"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_16",
    "data-name": "Mask Group 16",
    transform: "translate(-622 -625)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(613.862 630)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M66.573,14.727c-.928,1.022-1.7.894-2.244-.375-.216-.5-.407-1.016-.657-1.5-.091-.176-.321-.28-.543-.462v2.116q0,5.84,0,11.68a2.9,2.9,0,0,1-3.238,3.243c-1.509,0-.889,0-2.4,0-.3,0-.5.02-.619.4a5.829,5.829,0,0,1-11.308-.13,1.94,1.94,0,0,0-.1-.219H28.636c-1.547,3.558-3.319,4.873-6.317,4.683-2.457-.156-4.413-1.894-5.248-4.726-.382,0-.791.006-1.2,0-1.879-.031.481.1-1.372-.139a5.219,5.219,0,0,1-4.477-5.209q-.043-9.351,0-18.7A5.375,5.375,0,0,1,15.442.016C30.251,0,34.414-.015,49.224.023A14.058,14.058,0,0,1,62.357,9.665c.173.523.39.782.952.691.192-.031.394.009.59-.007a1.342,1.342,0,0,1,1.5.976c.348.888.776,1.744,1.17,2.614ZM60.93,22.534c-1.068-.16-2.076-.336-3.092-.454a2.745,2.745,0,0,1-1.773-.856c-1.013-1.058-2.166-1.989-3.115-3.1a4.254,4.254,0,0,0-4.358-1.773,5.29,5.29,0,0,1-1.046-.018c-7.632,0-8.876,0-16.507,0-.371,0-.743.026-1.114.026-7.128-.008-10-.013-17.126-.038-.5,0-.628.156-.624.636.022,2.252,0,4.505.013,6.758a3.288,3.288,0,0,0,3.51,3.547c1.705.028-.847,0,.859.014a.581.581,0,0,0,.674-.508,5.818,5.818,0,0,1,11.218.008.556.556,0,0,0,.633.482c6.714-.009,9.17-.009,15.884,0a.58.58,0,0,0,.672-.515,5.61,5.61,0,0,1,2.5-3.332,5.851,5.851,0,0,1,8.715,3.255c.07.221.3.554.464.558,1.7.038,1.282.04,2.987-.007a.83.83,0,0,0,.6-.536c.053-1.369.028-2.742.028-4.15M12.273,5.121H56.784c-.265-.221-.424-.362-.593-.491a12.206,12.206,0,0,0-7.645-2.483c-14.433,0-18.219,0-32.651.006a5.786,5.786,0,0,0-1.171.109,3.083,3.083,0,0,0-2.451,2.859m48.662,15.2c0-2.22.024-4.36-.007-6.5a11.693,11.693,0,0,0-1.813-6.012.854.854,0,0,0-.844-.453c-2.668.016-5.336.008-8,.01-.168,0-.336.025-.507.039v6.779a8.74,8.74,0,0,0,1.039-.007,2.273,2.273,0,0,1,2.024.813c1.5,1.53,3.051,3.01,4.6,4.494a1.639,1.639,0,0,0,.77.435c.879.165,1.77.265,2.745.4M38.2,7.415H31.128v6.728H38.2Zm9.288-.006H40.423v6.738h7.069ZM21.828,14.148h7.047V7.389H21.828ZM19.555,7.421H12.239v6.729h7.316ZM51.228,24.69a3.66,3.66,0,0,0-3.657,3.672,3.672,3.672,0,1,0,3.657-3.672M26.493,28.364a3.659,3.659,0,0,0-7.319-.034,3.659,3.659,0,1,0,7.319.034",
    transform: "translate(0.065 0)",
    fill: "#85af26"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPassages);
export default __webpack_public_path__ + "static/media/icon_passages.3873fe38320d0d86fe1dc3bd3f5380a5.svg";
export { ForwardRef as ReactComponent };